// Where a phone sheet goes while the keyboard is up. iOS doesn't shrink the
// layout viewport for the keyboard (dvh and bottom: 0 stay put), it covers the
// bottom of the screen and may scroll the page; only window.visualViewport
// knows what is left. The sheet then sits on the keyboard (`bottom`, in the
// layout viewport's terms) and fits the visible height less a gap at the top.

const TOP_GAP = 12
const SLACK = 1

export function fitSheet({ innerHeight, vvHeight, vvTop }: { innerHeight: number; vvHeight: number; vvTop: number }) {
  const bottom = Math.max(0, Math.round(innerHeight - vvTop - vvHeight))
  if (vvHeight >= innerHeight - SLACK && bottom <= SLACK) return null
  return { bottom, maxHeight: Math.round(vvHeight - TOP_GAP) }
}
